const priceFormatter = new Intl.NumberFormat('de-de', {
  style: 'currency',
  currency: 'EUR',
  minimumFractionDigits: 0
});

export const formatEurPrice = (price) => {
  return priceFormatter.format(price);
};
